export const GUARANTEED_RENT_WITH_BELONG_X_STRINGS = {
  'guarantedRentWithBelongXSection.topText':
    'Looking to manage the home yourself?',
  'guarantedRentWithBelongXSection.title': 'Get Guaranteed Rent With',
  'guarantedRentWithBelongXSection.cta': 'LEARN MORE',
};
